/* React Redux */
import React, { Component, PropTypes } from 'react'

/* Utilities */

import SwitchOn from 'assets/switch-on.svg'
import SwitchOff from 'assets/switch-off.svg'

/* Styles */
import './index.css'


export default class Switch extends Component {

  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      value: props.value,
      input: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value === nextProps.value) return
    this.setState({ value: nextProps.value })
  }


  hasChanged() {
    return !(this.state.value == this.props.value )
  }

  isValid() {
    const { validate } = this.props
    const { value } = this.state
    return !validate || validate(value)
  }

  getClassName() {
    const {
      className
    } = this.props
    let classNameArr = className ?className.split(' '):[]
    classNameArr.push('switch', 'widget')
    if (this.hasChanged()) classNameArr.push('changed')
    return  classNameArr.join(' ')
  }

  toggle() {
    //if (!this.isValid()) return
    let value = !this.state.value
    this.setState({ value })
    if (this.props.onSave) this.props.onSave(value)
  }


  onClick(e) {
    e.stopPropagation()
    e.preventDefault()
    this.toggle()
  }

  renderLabel() {
    const { label, labelWidth } = this.props
    if (!label) return null
    var style = (!labelWidth)?{}:{width: labelWidth+"px"}
    return (
      <div className="inputLabel" style={ style }>{ label }</div>
    )
  }

  renderIcon() {
    //console.log("renderIcon",this.state.value)
    const {
        value
    } = this.state
    if (value) return (<SwitchOn className="switch-button" width="64" height="32"></SwitchOn>)
    return (<SwitchOff className="switch-button" width="64" height="32"></SwitchOff>)
  }

  render() {
    const {
        title,
        placeholder,
        labelWidth,
        disabled,
        labelRight
    } = this.props
    const {
        edit,
        value,
        input
    } = this.state
    var style = (!labelWidth)?{}:{minWidth: (110+labelWidth).toString() + "px"}
    return (
      <div
        className={ this.getClassName() }
        onClick={ this.onClick.bind(this)}
        style={ style }
      >
        <div className="toolbar-wrapper">
          { !labelRight && this.renderLabel() }
          <button className="input-wrapper" title={title}>
            { this.renderIcon() }
          </button>
          { labelRight && this.renderLabel() }
        </div>
      </div>
    )
  }
}

Switch.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  labelRight: PropTypes.bool,
  labelWidth: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.bool,
  defaultValue: PropTypes.bool,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func,
  onUndo: PropTypes.func,
  onSave: PropTypes.func,
  onEdit: PropTypes.func,
  validate: PropTypes.func,
  disabled: PropTypes.bool,
  saveTitle: PropTypes.string,
  resetTitle: PropTypes.string,
  clearTitle: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/app/widget/switch/index.jsx